/* Countdown del aviso de despacho — snippets/ed-delivery-cutoff.liquid.
   Se carga una vez desde el layout para seguir andando aunque el snippet
   entre al DOM por un morph del cart drawer (los <script> inline no
   se ejecutan cuando el contenido se inyecta por morph). */
(function () {
  if (window.__edDeliveryCutoffInit) return;
  window.__edDeliveryCutoffInit = true;

  var CUTOFF_HOUR_UY = 17;
  var UY_OFFSET_HOURS = -3; // Uruguay UTC-3, sin DST desde 2015

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function nowInUY() {
    var d = new Date(Date.now() + UY_OFFSET_HOURS * 3600 * 1000);
    return { day: d.getUTCDay(), hour: d.getUTCHours() };
  }

  // true si AHORA es Lun-Vie UY y antes de las 17:00 UY
  function isOpen() {
    var uy = nowInUY();
    return uy.day >= 1 && uy.day <= 5 && uy.hour < CUTOFF_HOUR_UY;
  }

  // Timestamp UTC del próximo cutoff (17:00 UY = 20:00 UTC), saltando weekends
  function nextCutoffMs() {
    var now = Date.now();
    var d = new Date();
    var cutoff = new Date(Date.UTC(
      d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(),
      CUTOFF_HOUR_UY - UY_OFFSET_HOURS, 0, 0, 0
    ));
    if (cutoff.getTime() <= now) {
      cutoff.setUTCDate(cutoff.getUTCDate() + 1);
    }
    while (true) {
      var dayUY = new Date(cutoff.getTime() + UY_OFFSET_HOURS * 3600 * 1000).getUTCDay();
      if (dayUY !== 0 && dayUY !== 6) break;
      cutoff.setUTCDate(cutoff.getUTCDate() + 1);
    }
    return cutoff.getTime();
  }

  function tick() {
    var nodes = document.querySelectorAll('.ed-delivery');
    if (!nodes.length) return;
    if (document.hidden) return;

    var open = isOpen();
    var countdownText = '';
    if (open) {
      var diff = Math.max(0, nextCutoffMs() - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      countdownText = ' · ' + h + ':' + pad(m) + ':' + pad(s);
    }

    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var todayEl = n.querySelector('[data-state="today"]');
      var closedEl = n.querySelector('[data-state="closed"]');
      if (open) {
        if (todayEl) todayEl.hidden = false;
        if (closedEl) closedEl.hidden = true;
        var cd = n.querySelector('[data-countdown]');
        if (cd) cd.textContent = countdownText;
      } else {
        if (todayEl) todayEl.hidden = true;
        if (closedEl) closedEl.hidden = false;
      }
    }
  }

  function start() {
    tick();
    setInterval(tick, 1000);

    // El cart drawer entra y se actualiza por morph. Cuando aparece un
    // nodo .ed-delivery nuevo, tickear al instante en vez de esperar
    // hasta el próximo segundo del setInterval.
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var el = added[j];
            if (el.nodeType !== 1) continue;
            if ((el.classList && el.classList.contains('ed-delivery')) ||
                (el.querySelector && el.querySelector('.ed-delivery'))) {
              tick();
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
